import Icon from '@/components/Icon/Icon';
import { noop, stopEvent } from '@/utils/util';
import React, { Component } from 'react';
import classNames from 'classnames';
import IconFont from '../../Icon/IconFont';
import styles from './MenuItem.scss';

class MenuItem extends Component {
  static defaultProps = {
    hasBorder: true,
    onClick: noop,
    onMouseEnter: noop,
    onMouseLeave: noop,
    title: '',
    disabled: false,
  }

  onClick = (e) => {
    const { index, onClick } = this.props;
    onClick(e, { index });
    stopEvent(e);
    // console.log('MenuItem::onClick', index);
  }

  onMouseEnter = (e) => {
    const { index, onMouseEnter } = this.props;
    onMouseEnter(e, { index });
    // console.log('MenuItem::onMouseEnter', index);
  }

  onMouseLeave = (e) => {
    const { index, onMouseLeave } = this.props;
    onMouseLeave(e, { index });
    // console.log('MenuItem::onMouseLeave', index);
  }

  render() {
    const {
      children,
      iconName,
      iconFontName,
      className,
      hasBorder,
      title,
      disabled,
    } = this.props;
    const classes = classNames(className, styles['item'], {
      [styles['item-border']]: hasBorder,
    });
    const itemDisable = classNames({
      [styles['item-disabled']]: disabled,
    });
    return (
      <li
        className={classes}
        onClick={this.onClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        title={title}
      >
        <span className={itemDisable}>
          { iconName && <Icon name={iconName} className={styles['icon']}/> }
          { iconFontName && <IconFont name={iconFontName} className={styles['icon']}/> }
          { children }
        </span>
      </li>
    );
  }
}


export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuItem/MenuItem.js